module.exports = __webpack_public_path__ + "img/70.0ef63399.jpg";